import _ from 'lodash';

export function deepMerge(target, source) {
  return _.mergeWith(target, source, (targetValue, sourceValue) => {
    // Check if the source value is an array
    if (_.isArray(sourceValue)) {
      // Reset the target array to an empty list before merging
      return sourceValue;
    }
    // Check if the source value is an object with a condition
    if (_.isObject(sourceValue) && sourceValue.condition) {
      const { condition, value } = sourceValue;
      // If the condition is met, return the specified value
      if (condition(targetValue)) {
        return value;
      }
      // If the condition is not met, return the target value to prevent merging
      return targetValue;
    }
    // Use lodash's default merging behaviour for other cases
    return undefined;
  });
}